import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE, heroGuarantees, packDescription } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-seyes" data-id="element-107" data-mp="4lqf8l2zysy8">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-margin sm:left-8 lg:left-12" data-id="element-108" data-mp="4njpsbgqdxbi" />

      <div className="relative mx-auto max-w-6xl px-8 pb-16 pt-4 sm:px-14 sm:pb-20 sm:pt-6 lg:pb-28" data-id="element-109" data-mp="xae7x1q2sklt">
        

        <div className="mt-4 flex flex-col sm:mt-12 lg:mt-16 lg:grid lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-12" data-id="element-110" data-mp="sb1efy4p8fa9">
          <div className="contents lg:block" data-id="element-111" data-mp="nb6mrsd3nlo5">
            <motion.h1 initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE
          }} className="order-1 text-center font-display text-[2.15rem] leading-[1] sm:leading-[0.95] lg:text-left tracking-tight text-ink sm:text-7xl sm:leading-[0.95] lg:text-[5.4rem]" data-id="element-112" data-mp="neklmqmk1cqu">
              Préparez une année entière de{' '}
              <span className="relative inline-block whitespace-nowrap" data-id="element-113" data-mp="399jm7a81g94j">
                <motion.span aria-hidden="true" initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.3,
                delay: 0.25,
                ease: EASE
              }} className="absolute inset-x-[-0.08em] bottom-[0.08em] top-[0.38em] -z-0 origin-left -rotate-1 rounded-[0.12em] bg-amber-300/80" data-id="element-114" data-mp="3e8wielksusjs" />
                <span className="relative" data-id="element-115" data-mp="2vi54d6pvadz2">sciences</span>
              </span>{' '}
              en seulement{' '}
              <span className="relative inline-block whitespace-nowrap italic text-pen" data-id="element-116" data-mp="2hk87sabey7ke">
                5 minutes
                <svg aria-hidden="true" viewBox="0 0 200 14" preserveAspectRatio="none" className="absolute -bottom-1.5 left-0 h-3 w-full sm:-bottom-2.5" data-id="element-117" data-mp="2lk8vklkejv44">
                  <motion.path d="M3 9 C 45 3, 95 2, 135 6 S 185 11, 197 4" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" vectorEffect="non-scaling-stroke" initial={{
                  pathLength: 0
                }} animate={{
                  pathLength: 1
                }} transition={{
                  duration: 0.3,
                  delay: 0.35,
                  ease: EASE
                }} data-id="element-118" data-mp="nat8heoiaqma" />
                </svg>
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.08,
            ease: EASE
          }} className="order-3 mx-auto mt-4 max-w-xl text-center text-[15px] lg:mx-0 lg:text-left leading-snug text-ink/75 sm:mt-8 sm:text-xl sm:leading-relaxed" data-id="element-119" data-mp="1126owjr4b8d3">
              Arrêtez d’improviser. Entrez en classe avec vos supports prêts pour expliquer,
              expérimenter et inspirer.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.16,
            ease: EASE
          }} className="order-4 mt-5 sm:mt-8 lg:mt-10" data-id="element-120" data-mp="218tqjxsdnefx">
              <div className="flex justify-center lg:justify-start" data-id="element-121" data-mp="2g1wyddg62dtg">
                <CtaButton href="#offer-card" className="w-full sm:w-auto" data-id="element-122" data-mp="2kxknxtyk98zh" />
              </div>
              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-[13px] text-ink/70 sm:mt-6 sm:gap-x-6 sm:text-sm lg:justify-start" data-id="element-123" data-mp="2p1sb3mpdegvl">
                {heroGuarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-124" data-mp="unj0xedciwmf">
                    <CheckIcon className="h-4 w-4 text-pen" aria-hidden="true" data-id="element-125" data-mp="zlaqw2ufk8nz" />
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>

          <motion.figure initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.12,
          ease: EASE
        }} className="relative order-2 mx-auto mt-4 w-full max-w-md sm:mt-12 sm:pt-10 lg:mt-0" data-id="element-126" data-mp="3vhp5ny5g6eqi">
            <div aria-hidden="true" className="absolute right-0 top-0 z-10 hidden rotate-[-5deg] items-end gap-1 sm:flex" data-id="element-127" data-mp="3hphdkjp3zby5">
              <svg viewBox="0 0 60 50" className="h-10 w-12 text-pen" fill="none" data-id="element-128" data-mp="3csqv5ppu049k">
                <path d="M56 6 C 40 4, 18 12, 10 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-129" data-mp="3rh55smthox0o" />
                <path d="M4 32 L10 42 L18 34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-130" data-mp="3mnslupzr9ee9" />
              </svg>
              <span className="font-hand text-[1.7rem] leading-[0.9] text-pen" data-id="element-131" data-mp="2u0y0zrz10d09">
                6 volumes
                <br data-id="element-132" data-mp="19i5fqm46teiq" />+ 5 bonus
              </span>
            </div>
            <img src={PRODUCT_IMAGE} alt="Coffret SCIENCES PRÊTES : six volumes du CP au CM2 dont le laboratoire, avec guides, fiches et corrigés" className="relative mx-auto h-60 w-auto drop-shadow-[0_20px_24px_rgba(20,32,61,0.22)] sm:h-auto sm:w-full" data-id="element-133" data-mp="19gub6k2x42qk" />
            <figcaption className="mx-auto mt-3 max-w-sm text-center text-xs leading-snug text-ink/70 sm:mt-8 sm:text-sm sm:leading-relaxed" data-id="element-134" data-mp="14klyreg3unn3">
              {packDescription}
            </figcaption>
          </motion.figure>
        </div>
      </div>
    </section>;
}